module.exports = __webpack_public_path__ + "static/media/img-1-modal-premium-3.fe13464a.png";